import React, {useState} from 'react'

export default function Demo() {

    return(
        <div>
            <h1>Demo</h1>
            <div>
            <iframe src="https://drive.google.com/file/d/1q0DgDjqTSXnRVKLKjmXFf7JLe4be7V07/preview" width="640" height="480" allow="autoplay"></iframe>
            </div>
        </div>
    )
}